import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy /app/* bookmarks -> /*/
export const Route = createFileRoute("/app/$")({
	beforeLoad: ({ params }) => {
		const splat = params._splat;
		throw redirect({
			href: splat ? `/${splat}` : "/timer",
		});
	},
});
